const NotFound: React.FC = () => {
  return (
    <div>
      <h2 className="centered-text font-color">
        Error: 404, the page you are searching for does not exist
      </h2>
    </div>
  );
};

export default NotFound;
